import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { clerkServiceErrorVisibleAtom } from '../stores/clerk-service-error.store';

export function ClerkServiceErrorDialog() {
  const { t } = useTranslation();
  const [visible, setVisible] = useAtom(clerkServiceErrorVisibleAtom);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  return (
    <Dialog open={visible} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('common.serviceError.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('common.serviceError.message')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} autoFocus>
          {t('common.serviceError.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
